module.exports = __webpack_public_path__ + "media/无触感归家--步行.9831ce33.mp4";